<template>
  <ul
    ref="root"
    :class="$style['usps']"
    :style="[playstateVar, { 'grid-row': uspRow }]">
    <li
      v-for="(item, n) in items"
      :key="`usps${n}`"
      :class="$style['usps__item']">
      <SvgIcon :class="$style['usps__icon']" :name="item.icon" />
      {{ item.title }}
    </li>
  </ul>
</template>
<script setup>
const { $t } = useNuxtApp()
defineProps({
  uspRow: {
    type: [Boolean, Number],
    default: null
  }
})
const root = ref()
const observer = ref()
const playState = ref('paused')
const items = ref([
  {
    title: $t('usps/general/free-shipping-above'),
    icon: 'Map/truck-line'
  },
  {
    title: $t('usps/general/shipped-today'),
    icon: 'Business/mail-send-line'
  },
  {
    title: $t('usps/general/pay-with-afterpay'),
    icon: 'Finance/shopping-cart-line'
  },
  {
    title: $t('usps/shops/shop-amount'),
    icon: 'Finance/store-line'
  }
])

const playstateVar = computed(() => {
  return {
    '--playstate-var': `${playState.value}`
  }
})

onMounted(() => {
  observer.value = new IntersectionObserver(
    e => {
      if (e[0].isIntersecting === true) {
        playState.value = 'running'
      }
    },
    { threshold: 1 }
  )
  observer.value.observe(root.value)
})

</script>
<style module lang="scss">
.usps {

  border-bottom: 1px solid var(--grey-lighter);
  border-top: 1px solid var(--grey-lighter);

  grid-column: 1 / -1;
  align-items: center;
  justify-content: space-evenly;
  display: inline-flex;
  padding: var(--spacing);
  width: 100%;
  position: relative;
  overflow: hidden;

  @media (max-width: #{($breakpoint-mobile)}) {
    grid-column: 1 / 3;
  }

  @media (max-width: #{($breakpoint-mobile)}) {
    grid-column: 1 / 3;
  }

  @media (max-width: #{$breakpoint-desktop}) {
    height: calc(var(--spacing ) * 6);
    justify-content: center;
  }

  &__icon {
    flex-shrink: 0;
  }

  &__item {
    border-radius: 999px;
    align-items: center;
    font-size: var(--font-size-xs);
    justify-content: center;
    overflow: hidden;
    color: var(--grey);
    display: inline-flex;
    gap: var(--spacing);
    padding: var(--spacing) calc(var(--spacing ) * 2);
    will-change: opacity;
    white-space: nowrap;

    opacity: 0.8;

    @for $i from 0 through 3 {
      &:nth-child(3n + #{$i + 1}) {
        animation: highlight 20s ($i * 5s) infinite;
      }
    }

    @media (max-width: #{$breakpoint-desktop}) {
      font-size: var(--font-size-s);
      width: 100%;
      flex: 1;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      opacity: 0;
      animation-timing-function: var(--transition-easing);

      @for $i from 0 through 3 {
        &:nth-child(3n + #{$i + 1}) {
          animation: growIn 20s ($i * 5s) infinite;
        }
      }
    }

  }

}

@keyframes highlight {
  0% {
    color: var(--grey);
  }

  10%, 25% {
    color: var(--black);
  }

  26%, 100% {
    color: var(--grey);
  }

}

@keyframes growIn {
  0% {
    opacity: 0;
  }

  1%, 22%{
    color: var(--black);
    opacity: 1;
  }

  25% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

</style>
